import type { CSSProperties, ChangeEvent } from 'react'

interface FieldProps {
  label?: string
  type?: string
  placeholder?: string
  value?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  hint?: string
  suffix?: string
  dir?: 'ltr' | 'rtl'
  disabled?: boolean
  maxLength?: number
  inputStyle?: CSSProperties
  style?: CSSProperties
}

export function Field({ label, type = 'text', placeholder, value, onChange, hint, suffix, dir, disabled, maxLength, inputStyle, style }: FieldProps) {
  return (
    <label style={{ display: 'block', ...style }}>
      {label && (
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--fg)', marginBottom: 6 }}>
          {label}
        </div>
      )}
      <div style={{ position: 'relative' }}>
        <input
          type={type}
          placeholder={placeholder}
          aria-label={label}
          value={value}
          onChange={onChange}
          dir={dir}
          disabled={disabled}
          maxLength={maxLength}
          style={{
            width: '100%',
            padding: '11px 14px',
            paddingInlineEnd: suffix ? 80 : 14,
            fontSize: 14,
            fontFamily: 'inherit',
            color: 'var(--fg)',
            background: 'white',
            border: '1px solid var(--border-default)',
            borderRadius: 10,
            outline: 'none',
            transition: 'all 150ms',
            ...(type === 'date' ? {
              // iOS native date controls can ignore the available width.
              appearance: 'none',
              WebkitAppearance: 'none',
              boxSizing: 'border-box',
              minWidth: 0,
              maxWidth: '100%',
              minHeight: 44,
            } : {}),
            ...inputStyle,
          }}
        />
        {suffix && (
          <div style={{
            position: 'absolute',
            insetInlineEnd: 12,
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: 12,
            color: 'var(--fg-subtle)',
          }}>
            {suffix}
          </div>
        )}
      </div>
      {hint && (
        <div style={{ fontSize: 12, color: 'var(--fg-subtle)', marginTop: 6 }}>{hint}</div>
      )}
    </label>
  )
}
